import React, { useEffect } from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { useUser } from '../../contexts/UserContext';
import { Navigate } from 'react-router-dom';
import FinancialDashboardComponent from './components/FinancialDashboard';

// Super admin configuration
const SUPER_ADMIN_EMAILS = ['emmanueljones05@gmail.com'];

const FinancialDashboard: React.FC = () => {
  const { currentUser, isLoading } = useUser();
  
  // Check if user is a super admin
  const isSuperAdmin =
     currentUser && currentUser.email && SUPER_ADMIN_EMAILS.includes(currentUser.email);
  
  // If not a super admin, redirect to home
  if (!isLoading && !isSuperAdmin) {
    return <Navigate to='/dashboard' replace />;
  }
  
  return (
    <Box sx={{ p: 3 }}>
      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Financial Dashboard
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" paragraph>
          Track user payments, subscriptions, and revenue metrics
        </Typography>
      </Paper>
      
      <FinancialDashboardComponent />
    </Box>
  );
};

export default FinancialDashboard; 